import { createNotifyMeAPI, deleteNotifyMeAPI } from '@common/api/api';
import { ANALYTICS_EVENTS } from '@common/analytics/AnalyticsEvents';
import Const from '../config/const';
import { addParamsToAnalitycs } from './application';
import { loadAdvisor } from './advisors';
import { toCamelCase } from '../../common/config/utils';
import { getAdvisorSlug } from '../project_items/helper_functions';

const createProgressAction = () => ({
  type: Const.notifyMe.progress
});

const createErrorAction = error => ({
  type: Const.notifyMe.error,
  payload: {
    error
  }
});

const createSuccessAction = advisor => ({
  type: Const.notifyMe.success,
  payload: {
    advisor
  }
});

const responseHandler = (promise, notifyMeParams, dispatch) => {
  const { clickSource } = notifyMeParams;
  dispatch(addParamsToAnalitycs({
    [ANALYTICS_EVENTS.ADVISOR_ALERT_SET]: { 'click source': clickSource }
  }));
  promise
    .then((res) => {
      const { advisor } = res;
      dispatch(createSuccessAction(advisor));
    })
    .catch(error => {
      error
        .json()
        .then(jsonError => {
          dispatch(createErrorAction(toCamelCase(jsonError)));
        })
        .catch(e => {
          dispatch(createErrorAction(e));
        });
    });
};

export const notifyMeAction = ({ notifyMeParams }) => (dispatch) => {
  const { notifyMeSwitchValue, advisorId, additionParams } = notifyMeParams;
  dispatch(createProgressAction());
  if (notifyMeSwitchValue) {
    responseHandler(createNotifyMeAPI(advisorId, additionParams), notifyMeParams, dispatch);
  } else {
    responseHandler(deleteNotifyMeAPI(advisorId), notifyMeParams, dispatch);
  }
};

const getNotifyMeData = advisorId => (dispatch) => {
  if (advisorId) {
    dispatch(loadAdvisor(getAdvisorSlug({ advisorId })));
  }
};

export const clearLocalState = () => ({
  type: Const.notifyMe.clear
});

const displayNotifyMeAction = (shouldDisplay, advisorId, clickSource) => ({
  type: Const.notifyMe.displayNotifyMe,
  shouldDisplay,
  advisorId,
  clickSource
});

export const displayNotifyMe = (shouldDisplay, advisorId, clickSource, needToLoadAdv = true) => (dispatch) => {
  if (advisorId && needToLoadAdv) {
    dispatch(getNotifyMeData(advisorId));
  }
  dispatch(displayNotifyMeAction(shouldDisplay, advisorId, clickSource));
};
